import { utcToZonedTime } from 'date-fns-tz';
import { add, differenceInSeconds, format, parse } from 'date-fns';
import { Availability } from '@/menu/pizza/pizzaMenuTypes';

export const getEndTime = (storeTimezone: string, intervalStartTime = '', duration = '', isBufferEndTime = false) => {
  // Get now in store's timezone
  const now = utcToZonedTime(new Date(), storeTimezone);
  // Parse intervalStartTime as today in store's timezone
  const [hours, mins, seconds] = intervalStartTime.split(':').map(Number);
  const start = new Date(now);
  start.setHours(hours, mins, seconds, 0);
  // Parse duration only hours
  const [dh, dm, ds] = duration.split(':').map(Number);
  // Calculate end time
  const end = add(start, { hours: dh });
  const endWithBuffer = add(start, { hours: dh, minutes: dm, seconds: ds });
  return isBufferEndTime ? endWithBuffer : end;
};

export const timeToSeconds = (duration: string): number => {
  const [h, m, s] = duration.split(':').map(Number);
  return h * 3600 + m * 60 + s;
}

export const checkIsPastIntervalStartTime = (now: Date, intervalStartTime='') => {
  if(!intervalStartTime) {
    return true;
  }
  const [hours, mins, seconds] = intervalStartTime.split(':').map(Number);
  const intervalStart = new Date(now);
  intervalStart.setHours(hours, mins, seconds || 0, 0);
  return now >= intervalStart;
}
export const getTimerDetails= (availability: Availability[] | undefined, occasion: string, storeTimezone: string) => {
  const occasionAvailability = availability?.find((avail) => avail.occasion.includes(occasion));
  if(!occasionAvailability?.duration || !occasionAvailability?.intervalStartTime) {
    return {
      isAvailable: true,
      timeUntilExpiration: Infinity
    }
  }
  // Check if duration is not 24 hours (in format HH:mm:ss)
  const isNot24Hours = timeToSeconds(occasionAvailability.duration) < timeToSeconds('23:59:00');
  const now = utcToZonedTime(new Date(), storeTimezone);
  const isPastIntervalStart = checkIsPastIntervalStartTime(now , occasionAvailability.intervalStartTime);

  const end = getEndTime(storeTimezone,occasionAvailability?.intervalStartTime, occasionAvailability?.duration);
  const diff = differenceInSeconds(end, now);
  return {
    duration: isNot24Hours ? occasionAvailability?.duration : '',
    intervalStartTime: occasionAvailability?.intervalStartTime,
    isAvailable: diff > 0 && isPastIntervalStart,
    timeUntilExpiration: diff
  }
};

export const convertToHHmmss = (timeStr: string | null | undefined, formatString: string) => {
  if(!timeStr || !formatString) {
    return '';
  }
  // Parse the time string (e.g., "12:00am") to a Date object
  const parsedDate = parse(timeStr, formatString, new Date());
  // Format it to "HH:mm:ss" in the given timezone
  return format(parsedDate, 'HH:mm:ss');
};

export const checkIsPastEndTime = (storeTimeZone: string, duration: string, intervalStartTime: string) => utcToZonedTime(new Date(), storeTimeZone) > getEndTime(storeTimeZone, intervalStartTime, duration, true);

